import Pusher from 'pusher-js'
import config from './config'

Pusher.logToConsole = config.isDev

export default new Pusher(config.pusherKey, {
  cluster: 'mt1',
  forceTLS: true
})